<div class="game-event-dialog">
  <div class="hero" [style.border-left]="'5px solid ' + (data.EventColor || '#1976d2')">
    <div class="dialog-header">
      <div class="title-wrap">
        <p class="event-type">{{ data.EventType || 'GAME' }}</p>
        <h2>{{ data.HomeTeamName }} - {{ data.AwayTeamName }}</h2>
        <p class="subtitle">{{ data.DivisionName || data.Title || 'Game event' }}</p>
      </div>
      <button mat-icon-button (click)="close()" aria-label="Close game event details dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body">
    <div class="row">
      <span class="label">{{ 'SCHEDULE.START' | translate }}</span>
      <span class="value">{{ toDisplayDate(data.EventStartUTC) | date: 'EEE, yyyy-MM-dd HH:mm' }}</span>
    </div>

    <div class="row">
      <span class="label">{{ 'SCHEDULE.END' | translate }}</span>
      <span class="value">{{ toDisplayDate(data.EventEndUTC) | date: 'EEE, yyyy-MM-dd HH:mm' }}</span>
    </div>

    @if (data.Venue) {
      <div class="row">
        <span class="label">{{ 'SCHEDULE.VENUE' | translate }}</span>
        <span class="value">{{ data.Venue }}</span>
      </div>
    }

    @if (data.FirstName || data.LastName) {
      <div class="row">
        <span class="label">Scout</span>
        <span class="value">{{ data.LastName }}, {{ data.FirstName }}</span>
      </div>
    }

    @if (data.Comment) {
      <div class="comment-wrap">
        <span class="label">{{ 'SCHEDULE.COMMENT' | translate }}</span>
        <p>{{ data.Comment }}</p>
      </div>
    }
  </div>

  <div class="dialog-actions">
    @if (data.IsMyEvent) {
      <button mat-stroked-button color="warn" (click)="onDelete()">{{ 'GENERAL.DELETE' | translate | uppercase }}</button>
    }
    @if (data.GameId) {
      <button mat-stroked-button color="primary" (click)="onViewGame()">
        <mat-icon>sports</mat-icon>
        {{ 'SCHEDULE.VIEW_GAME' | translate | uppercase }}
      </button>
    }
    <button mat-flat-button color="primary" (click)="close()">{{ 'GENERAL.CLOSE' | translate | uppercase }}</button>
  </div>
</div>
